import { Avatar, Text } from "@clipboard-health/ui-components";
import { type AvatarSize } from "@clipboard-health/ui-theme";
import { Stack, type SxProps, type Theme } from "@mui/material";

interface Props {
  size?: AvatarSize;
  sx?: SxProps<Theme>;
  src?: string;
  /**
   * The first name of the person. If not provided, the fallback text will be displayed.
   */
  firstName?: string;
  /**
   * The last name of the person. If not provided, the fallback text will be displayed.
   */
  lastName?: string;
  /**
   * The text to display if the name is not provided.
   */
  fallbackText?: string;
  colorIndex?: number;
}

export function ProfileImage(props: Props) {
  const { src, firstName, lastName, fallbackText, size = "small", sx, colorIndex } = props;

  const colorOptions = ["primary", "secondary", "tertiary", "quaternary", "septenary"] as const;

  return (
    <Stack
      borderRadius="100%"
      // oxlint-disable-next-line typescript/no-misused-spread -- MUI SxProps union includes functions, but spreading in sx is standard MUI pattern
      sx={{ height: "max-content", position: "relative", ...sx }}
      alignItems="center"
      justifyContent="center"
    >
      <Avatar
        size={size === "small" ? "small" : "large"}
        src={src}
        alt="Profile"
        color={colorOptions[colorIndex ?? 0]}
      >
        <Text variant={size === "small" ? "body1" : "h3"}>
          {firstName
            ? `${firstName.charAt(0)}${lastName?.charAt(0) ?? ""}`.trim()
            : (fallbackText ?? "")}
        </Text>
      </Avatar>
    </Stack>
  );
}
